<template>
    <div class="content-area__heading">
            <top-nav>
                <div slot="title">
                    <h2 >Efetividade</h2>
                </div>
            </top-nav>
            <vx-card title="Revendedores" collapse-action :refresh-content-action="show_refresh" :download-card-action="show_download" @download="downloadBug" @refresh="refreshBug" 
            @toggle="toggle">
                <div>
                    <estatisticas-revendedores :refresh="refresh" :download="download" :close="close" v-on:download="(status) => show_download = status"></estatisticas-revendedores>
                </div>
            </vx-card>
    </div>
</template>

<script>
    export default {
        components: {
            EstatisticasRevendedores: () => import("./components/estatisticas-revendedores.vue"),
            TopNav: () => import("../../components/nav-bar/top-nav")
        },
        data:()=>({
            refresh:false,
            show_refresh:true,
            download:false,
            show_download:false,
            close:false,
        }),
        methods: {
                downloadBug(){
                    this.download = true 
                    this.$nextTick(() => {
                        this.download = false 
                    })
                },
                refreshBug(){
                    this.refresh = true
                    this.$nextTick(() => {
                        this.refresh = false
                    })
                },
                toggle(close){
                    close == false ? this.show_refresh = true : this.show_refresh = false
                    close == false ? 0 : this.show_download = false, 
                    this.close = true
                    this.$nextTick(() => {
                         this.close = false
                    })
                }
            }
    }
</script>